import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import {
  AngularFirestore,
  DocumentChangeAction,
} from '@angular/fire/compat/firestore';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';

import {  map } from 'rxjs/operators';
import { environment } from "src/environments/environment";



interface UserData {
  uid: any;
  email: string;
}


@Injectable({
  providedIn: 'root',
})
export class UserService {
  createdUserInstance: any;
  deviceInfo: any;
  isLoggedIn: boolean | undefined;
  isEntryDone: boolean | undefined;
  appIdtoget: any;
  constructor(
    private afAuth: AngularFireAuth,
    private afs: AngularFirestore,
    private router: Router,
    public http: HttpClient,
    private firestore: AngularFirestore
  ) { }





  async getUserByEmail(email: string) {
    try {
      console.log("Checking if user exists for email:", email);
      const querySnapshot = await this.afs.collection('users', ref => ref.where('email', '==', email)).get().toPromise();
  
      if (querySnapshot?.empty) {
        console.log("No user found with email:", email);
        return null;
      } else {
        // Assuming there is only one user with the given email, get the first document
        const doc = querySnapshot!.docs[0];
        const userData = doc.data() as UserData;
        console.log("User found with email:", userData);
        return userData;
      }
    } catch (error) {
      console.error('Error checking if user exists or fetching user data:', error);
      return null;
    }
  }
  

  uidN:any
  workspaces:any
  async createUseraccess(userObj: any, isCreateAccess: boolean,workspaceId:any) {
    try {
      const currentUser = localStorage.getItem('uid')?.toString();
      const d={
        userAccessuid:currentUser,
        workspaceId:workspaceId,
        role:userObj.role
      }
      // Convert email to lowercase for consistency
      const lowercaseEmail = userObj.email.toLowerCase();
      // Check if user with the given email already exists
  
 const userExists = await this.getUserByEmail(lowercaseEmail);
      if ( userExists !== null) {
        this.uidN=await this.getUserIDByEmail(lowercaseEmail)
        this.workspaces=userExists;
        // console.log("this.workspaces",this.workspaces);

        if (!this.workspaces.workspaces) {
          this.workspaces.workspaces = [];
      }
      
        const work=this.workspaces.workspaces;
        work.push(d)
        console.log(work,'user Exist workspace data',this.uidN);
        const data={
          email:userObj.email,
 content:`Dear Member,

 Welcome to our shared account for Phonetik! We're thrilled to extend this invitation to you and can't wait to start collaborating.
 
 As you've been invited to join our shared account.

 You can access the account using the following link: https://app.phonetik.ai/login.
 
 Your role selection ensures that you have the appropriate level of access to our shared resources, contributing to a smooth and efficient collaboration experience for everyone involved.
 
 If you have any questions during the registration process, don't hesitate to reach out to our support team.
 
 Thank you for joining us! We're excited to have you on board and look forward to achieving great things together.
 
 Best regards,
 Phonetik`,
          subject:'Welcome to Our Shared Phonetik Account: Your Role Inside'
         }
         console.log('User document updated successfully');
         this.sendEmail(data).subscribe({
          next:(res)=>{
            console.log(res)
          }
          ,error:(err)=>{
            console.log(err)
          }
         })
        // If user exists, update the userAccessuid field in Firestore
        const userDocRef = this.afs.collection('users').doc(this.uidN);
        await userDocRef.set({ workspaces:work}, { merge: true });
     
        console.log('User document updated successfully');
      }
  else{
    const w=[]
    w.push(d)
       // Create a new user with Firebase Authentication
       const password=await this.generatePass()
       console.log(password,'pass')
       const result = await this.afAuth.createUserWithEmailAndPassword(userObj.email, password);
       console.log('Check Your Email For Verification', result);
   
       if (result.user && result.additionalUserInfo?.isNewUser) {
         // If the user is newly created, update user information in Firestore
         const user = result.user;
         const uid = user.uid;
         this.uidN=uid
         const newUserRef = this.afs.collection('users').doc(uid);
         await newUserRef.set({
           uid: uid,
           email: lowercaseEmail,
           firstLogin:true,
           workspaces:w
          
         }, { merge: true });


         const data={
          email:userObj.email,
 content:`Dear Member,

 Welcome to our shared account for Phonetik! We're thrilled to extend this invitation to you and can't wait to start collaborating.
 
 As you've been invited to join our shared account, please check your email at ${userObj.email}. Your login credentials are as follows:
 
 Username: ${userObj.email}
 Password: ${password}
 You can access the account using the following link: https://app.phonetik.ai/first-password.
 
 Your role selection ensures that you have the appropriate level of access to our shared resources, contributing to a smooth and efficient collaboration experience for everyone involved.
 
 If you have any questions during the registration process, don't hesitate to reach out to our support team.
 
 Thank you for joining us! We're excited to have you on board and look forward to achieving great things together.
 
 Best regards,
 Phonetik`,
          subject:'Welcome to Our Shared Phonetik Account: Your Role Inside'
         }
         console.log('User document updated successfully');
         this.sendEmail(data).subscribe({
          next:(res)=>{
            console.log(res)
          }
          ,error:(err)=>{
            console.log(err)
          }
         })
        

        //  this.router.navigate(['/reset-password'])
         // Send email verification to the user
        //  let emailVerificationRedirectLinkSuffix = isCreateAccess ? "reset-password" : "";
        //  console.log("emailVerificationRedirectLinkSuffix", emailVerificationRedirectLinkSuffix);
        //  await user.sendEmailVerification({
        //    url: `${environment.baseUrl}/${emailVerificationRedirectLinkSuffix}`
        //  });
       }
  }
  return this.uidN;

   
    
    } catch (error) {
      console.error('Error:', error);
      throw error;
    }
  }


  getUserIDByEmail(lowercaseEmail: string): Promise<string | null> {
    return new Promise((resolve, reject) => {
      this.afs.collection('users').snapshotChanges().subscribe((usersSnapshot: DocumentChangeAction<any>[]) => {
        const userWithEmail = usersSnapshot.find(userSnapshot => userSnapshot.payload.doc.data().email === lowercaseEmail);
        if (userWithEmail) {
          const userId = userWithEmail.payload.doc.id;
          resolve(userId);
        } else {
          console.log('No user found with the provided email.');
          resolve(null);
        }
      });
    });
  }

   generatePass() {
    let pass = '';
    let str = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ' +
        'abcdefghijklmnopqrstuvwxyz0123456789@#$';
 
    for (let i = 1; i <= 8; i++) {
        let char = Math.floor(Math.random()
            * str.length + 1);
 
        pass += str.charAt(char)
    }
 
    return pass;
}
  
  async createMember(uid: string, id:string,data: any): Promise<void> {
    try {
        // Reference the user's document
        const userDocRef = this.firestore.collection('users').doc(uid);
        const userDocRef1 = userDocRef.collection('workspaces').doc(id);
        // Create a new collection inside the user's document
        const newCollectionRef = userDocRef1.collection('members');
        
        // Save new data in the new collection
       newCollectionRef.add(data)
    } catch (error) {
        console.error('Error saving new collection with reference UID:', error);
    }
  }







  async updateMember(data: any,role:any): Promise<any> {
    try {
      const workspaceid=localStorage.getItem('currentTitle')?.toString()
      // Execute two asynchronous tasks in parallel
      const task1Result= await this.updateUser(data,workspaceid,role);
      // Return the final value
      return 'member Updated'; // Replace with the actual final value
    } catch (error) {
      console.log(error);
      // Handle error appropriately
      throw error; // Re-throw the error or handle it as needed
    }
  }
userData:any;
userAccessId:any;
  // async updateUser(data:any,workspaceId:any,role:any): Promise<any> {
  //   // Define your first asynchronous function here
  //   return new Promise(async (resolve, reject) => {
  //     const userDocRef = this.firestore.collection('users').doc(data.memberId);
  //     const docSnapshot$ = userDocRef.get();
  //   const docSnapshot = await docSnapshot$.pipe(
  //       map(snapshot => {
  //         if (snapshot.exists) {
  //           const userData = snapshot.data();
  //         return userData;
  //         } else {
  //           throw new Error('Document does not exist');
  //         }
  //       })
  //     ).toPromise();
  //   this.userData=docSnapshot;
  //    if(this.userData){
  //     this.userData.workspaces.map((x:any)=>{
  //       if(x.workspaceId==workspaceId){
  //         x.role=role
  //       }
       
  //     })
  //    }

  //     resolve(this.userData)
  //   });
  // }

  async updateUser(data: any, workspaceId: any, role: any): Promise<any> {
    try {
      const userDocRef = this.firestore.collection('users').doc(data.memberId);
  
      // Get the document snapshot
      const docSnapshot = await userDocRef.get().toPromise();
  
      if (docSnapshot && docSnapshot.exists) {
        // Extract data from the snapshot
        this.userData = docSnapshot.data();
  
        // Update the user's workspace role
        if (this.userData && this.userData.workspaces) {
          this.userData.workspaces.forEach((workspace: any) => {
            if (workspace.workspaceId === workspaceId) {
              workspace.role = role;
              this.userAccessId=workspace.userAccessuid;
            }
          });
         await this.updateMemberData(data,this.userAccessId,role,workspaceId)
          // Update the Firestore document with the modified user data
          await userDocRef.update(this.userData);
  
          // Resolve with the updated user data
          return this.userData;
        } else {
          throw new Error('User data or workspaces are missing');
        }
      } else {
        throw new Error('Document does not exist');
      }
    } catch (error) {
      console.error('Error updating user:', error);
      throw error; // Re-throw the error or handle it as needed
    }
  }
  
  
  async updateMemberData(data: any, userAccessUid: any, role: any, workspaceId: any): Promise<any> {
    console.log(userAccessUid, 'accessUid');
    const userDocRef = this.firestore.collection('users').doc(userAccessUid)
      .collection('workspaces').doc(workspaceId)
      .collection('members').doc(data.id);
  
    return await userDocRef.set({ role }, { merge: true });
  }


  async getMemberData(uid: string,id:string): Promise<any> {
    try {
      // Reference the user's document
      const userDocRef = this.firestore.collection('users').doc(uid);
      const userDocRef1 = userDocRef.collection('workspaces').doc(id);
      // Get the observable for the 'member' subcollection
      const memberCollectionRef = userDocRef1.collection('members').snapshotChanges();
      return new Promise((resolve, reject) => {
        memberCollectionRef.pipe(
          map((actions) => {
            // Map the document change actions to the actual document data
            return actions.map(a => {
              const data = a.payload.doc.data();
              const id = a.payload.doc.id;
              return { id, ...data };
            });
          })
        ).subscribe((memberData: any[]) => {
          if (memberData.length > 0) {
            console.log(memberData,'md')
            resolve(memberData);
          } else {
            console.log('No member documents found for user:', uid);
            resolve([]);
          }
        }, (error: any) => {
          console.error('Error retrieving member data:', error);
          reject(error);
        });
      });
    } catch (error) {
      console.error('Error retrieving Member:', error);
      throw error; // Rethrow the error to handle it outside of this function
    }
}



async getMemberData1(uid: string): Promise<any> {
  try {
    const userDocRef = this.firestore.collection('users').doc(uid);
    const workspacesCollectionRef = userDocRef.collection('workspaces');

    const workspacesQuerySnapshot = await workspacesCollectionRef.get().toPromise();

    const members: any[] = [];

    if (workspacesQuerySnapshot && !workspacesQuerySnapshot.empty) {
      for (const workspaceDoc of workspacesQuerySnapshot.docs) {
        const workspaceId = workspaceDoc.id;
        const workspaceData = workspaceDoc.data();

        // Fetch workspace title
          const workspaceTitle = workspaceData;

        const membersCollectionRef = userDocRef.collection('workspaces').doc(workspaceId).collection('members').snapshotChanges();
        
        await new Promise((resolve, reject) => {
          membersCollectionRef.pipe(
            map((actions) => {
              // Map the document change actions to the actual document data
              return actions.map(a => {
                const data = a.payload.doc.data();
                const id = a.payload.doc.id;
                return { id, ...data };
              });
            })
          ).subscribe((memberData: any[]) => {
            if (memberData.length > 0) {
              console.log(memberData, 'md');
              // Push member data along with workspace title
              members.push(...memberData.map(member => ({ workspaceTitle, ...member })));
            } else {
              console.log('No member documents found for user:', uid);
            }
            resolve(memberData); // Resolve promise after subscription
          }, (error: any) => {
            console.error('Error retrieving member data:', error);
            reject(error);
          });
        });
      }
    }

    return members;
  } catch (error) {
    console.error('Error retrieving members:', error);
    throw error;
  }
}




  forgetPassword(email: string): Promise<void> {
    return new Promise(async (resolve, reject) => {
      try {
        // First check if the email exists in our users collection
        const userExists = await this.getUserByEmail(email);
        
        if (!userExists) {
          // If user doesn't exist, reject with a specific error message
          reject({ message: 'This email is not registered. Please sign up first.' });
          return;
        }
        
        // If user exists, proceed with password reset
        this.afAuth
          .sendPasswordResetEmail(email)
          .then(() => {
            console.log('Password reset email sent successfully to:', email);
            resolve();
          })
          .catch((error: any) => {
            console.error('Error sending password reset email:', error);
            reject(error);
          });
      } catch (error) {
        console.error('Error checking if user exists:', error);
        reject(error);
      }
    });
  }


  sendEmail(data:any){
    return this.http.post(environment.firebaseCloudfunction.sendEmail,data);
  }


  
}
